import { render } from "./MultisidebarMenu.vue?vue&type=template&id=8c744c2a&ts=true"
import script from "./MultisidebarMenu.vue?vue&type=script&lang=ts"
export * from "./MultisidebarMenu.vue?vue&type=script&lang=ts"

import "./MultisidebarMenu.vue?vue&type=style&index=0&id=8c744c2a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__